import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import { of } from "rxjs";
import { catchError, map, mergeMap, tap } from "rxjs/operators";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import {
  clientAccountsError,
  getMyClientAccounts,
  myClientAccountsLoaded,
  setSelectedClientAccountId,
} from "../actions/client-account.actions";
import { AccountService } from "app/services/account/account.service";
import { StorageUtilsService } from "app/services/storage-utils/storage-utils.service";
import { getSubscriptionsByClientAccount } from "../actions/subscriptions.actions";

@Injectable()
export class ClientAccountsEffect {
  actions$ = inject(Actions);
  _router = inject(Router);
  private _accountService = inject(AccountService);
  private _storageUtilsService = inject(StorageUtilsService);

  getMyClientAccounts$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(getMyClientAccounts),
      mergeMap(() => {
        return this._accountService.getAccountsClients().pipe(
          map((myClientAccounts) =>
            myClientAccountsLoaded({ myClientAccounts }),
          ),
          catchError((error) => of(clientAccountsError({ error }))),
        );
      }),
    );
  });

  setSelectedClientAccountIdEff$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(setSelectedClientAccountId),
      tap(({ selectedClientAccountId }) => {
        /** set selected folder value in storage */
        this._storageUtilsService.setSelectedAccountId(selectedClientAccountId);
      }),
      mergeMap(({ selectedClientAccountId }) => {
        return of(
          getSubscriptionsByClientAccount({
            clientAccountId: selectedClientAccountId,
          }),
        );
      }),
    );
  });
}
